module Core {
    angular.module('core').filter('conditionalTernaire', [() => {
        return (condition: boolean, thenTxt: string, elseTxt: string): string => {
            if (condition) {
                return thenTxt;
            }
            return elseTxt;
        };
    }]);
}